RivalIQ.module('export.views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.CompanyCountWarning = Marionette.ItemView.extend({
        template: '#exportCompanyCountWarningTemplate',
        className: 'callout callout-warning'
    });
});
